// API
import { apiFetch } from '../../app/apiFetch';

// Models
import { UserSettings } from './userModels';

/**
 * @function getAccessToken
 * Requests a new access token
 *
 * @return {object} User
 */
export function getAccessToken() {
    const endpoint = `/v1/user/buy_access_token`;
    const body = JSON.stringify({});

    return apiFetch('POST', endpoint, body);
}

/**
 * @function getUser
 * Gets current user
 *
 * @param {number} userId Target user ID
 * @return {object} User
 */
export function getUser(userId: number) {
    const endpoint = `/v2/users/${userId}`;

    return apiFetch('GET', endpoint);
}

/**
 * @function putUser
 * Patches updated user settings
 *
 * @param {number} userId Target user ID
 * @param {UserSettings} settings Target user's updated settings
 * @return {object} User
 */
export function putUser(userId: number, settings: UserSettings) {
    const endpoint = `/v2/users/${userId}`;
    const body = JSON.stringify({
        ...settings,
    });

    return apiFetch('PUT', endpoint, body);
}
